import React, { useState, useEffect } from 'react';
import ListReleaseNotes from '../../../components/Admin/ReleaseNotes/ListReleaseNotes';
import AddEditReleaseNoteForm from '../../../components/Admin/ReleaseNotes/AddEditReleaseNoteForm';
import Modal from "../../../components/Modal";
import { getReleaseNotesApi, getReleaseNotesDetaApi } from '../../../api/post';
import { getAccessTokenApi } from '../../../api/auth';
import { getCatReleaseNotesApi } from '../../../api/category';
import NewReleaseNote from '../../../components/Admin/ReleaseNotes/NewReleaseNote/NewReleaseNote';
import { errorModal, warningModal } from '../../../components/Alerts/Alerts';

export default function ReleaseNotes(props) {
    const [ releaseNotes, setReleaseNotes ] =  useState([]);
    const [ reloadReleaseNotes, setReloadReleaseNotes ] = useState([]);
    const [ postsBase, setPostsBase ] = useState(null);
    const [ reloadPostsBase, setReloadPostsBase ] = useState(false);
    const [ isVisibleModal, setIsVisibleModal ] = useState(false);
    const [ modalTitle, setModalTitle ] = useState("");
    const [ modalContent, setModalContent ] = useState(null);
    const [ categories, setCategories ] =  useState([]);
    const [ reloadCategories, setReloadCategories ] = useState([]);

    useEffect(() => {
        let token = getAccessTokenApi();
        getReleaseNotesDetaApi(token).then(response => {
            setReleaseNotes(response.posts);
        });

        setReloadReleaseNotes(false);
    }, [reloadReleaseNotes]);

    useEffect (() => {
        getReleaseNotesApi()
            .then(response => {
                if (response?.code !== 200){
                    warningModal("Advertencia", response.message);
                }else{
                    setPostsBase(response.posts);
                }
            })
            .catch(err => {
                errorModal	("Error", "Error del Servidor.");
            });

            setReloadPostsBase(false);
    }, [reloadPostsBase]);

    useEffect(() => {
        let token = getAccessTokenApi();
        getCatReleaseNotesApi(token).then(response => {
            setCategories(response.category);
        });

        setReloadCategories(false);
    }, [reloadCategories]);

    const addPost = () => {
        setIsVisibleModal(true);
        setModalTitle("Crear nueva Release Notes");
        setModalContent(
                <NewReleaseNote
                    setIsVisibleModal={setIsVisibleModal}
                    setReloadReleaseNotes={setReloadReleaseNotes}
                    releaseNotes={null}
                    categories={categories}
                    postsBase={null}
                    setReloadPostsBase={setReloadPostsBase}
                />
            );
    }

    const editPost = post => {
        setIsVisibleModal(true);
        setModalTitle("Editar Release Note");
        setModalContent(
                <AddEditReleaseNoteForm
                    setIsVisibleModal={setIsVisibleModal}
                    setReloadReleaseNotes={setReloadReleaseNotes}
                    releaseNotes={releaseNotes}
                    post={post}
                    categories={categories}
                    setReloadCategories={setReloadCategories}
                    postsBase={Array.isArray(postsBase) && postsBase.find(el => el._id === post._id)}
                />
            );
    }

    return (
        <div>
            <ListReleaseNotes 
                releaseNotes={releaseNotes} 
                setReloadReleaseNotes={setReloadReleaseNotes} 
                addPost={addPost}
                editPost={editPost}
                postsBase={postsBase}
            />

            <Modal
                title={modalTitle}
                isVisible={isVisibleModal}
                setIsVisible={setIsVisibleModal}
                setSize='xl'
            >
                {modalContent}
            </Modal>
        </div>
    )
}
